import {  BrowserRouter} from "react-router-dom";
import '../asset/css/App.css';
import Header from '../components/header/header';
import View3 from "./View3";

function App() {
  return (
    <div>
      <BrowserRouter forceRefresh={true}>
          <Header/>
          {/* <Navigation routes={dashboardRoutes}/> */}
          <View3 />
      </BrowserRouter>
    </div>
  );
}

export default App;
